import { FETCH_PRODUCT_LOCATIONS } from '../actions/types'

export default (state = [], action) => {
  switch (action.type) {
    case FETCH_PRODUCT_LOCATIONS:
      return action.payload
    default:
      return state
  }
}
